














































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VideoQuiz from "../components/VideoQuiz.vue";

import "@/styles/Videos.scss";
import * as franc from "franc";
import Loader from "../views/Loader.vue";
import BreadCrumb from "./breadCrumb.vue";
import TrainingBreadcrumb from "../components/TrainingBreadcrumb.vue";
import TraningVideos from "@/components/TraningVideos.vue";
import PdfViewer from "@/components/PdfViewer.vue";
import TraningQuiz from "./TraningQuiz.vue";
import { TrainingQuiz } from "../models/training-types";
@Component({
  components: {
    "video-learning": TraningVideos,
    "pdf-viewer": PdfViewer,
    swiper,
    "video-quiz": VideoQuiz,
    "traning-quiz": TraningQuiz,
    BreadCrumb: BreadCrumb,
    TrainingBreadcrumb,
    swiperSlide,
    "loader": Loader,
  },
})
export default class TrainingModules extends Vue {
  private service = new GeneralService();
  private items: GActivity[] = [];
  private chapters: GActivity[] = [];
  private isChapter = false;
  private isTopic = false;
  private attempted: number = 0;
  private level_id;
  private isVideoQuiz = false;
  private topicid = "";
  private topicname = "";
  private checkTopic = false;
  private watching = 0;
  private mcqlimit = 10000;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private isSmart = false;

  private videoKey = 0;
  private chapterId = '';
  public val: any = '';
  public nodataFound: boolean = false;
  private isPastPaper = false;
  public contentType: string = "";
  public contentIds: any;
  public IsArvo: boolean = false;
  public SloBased: boolean = false;
  public loading: boolean = false;
  newChapter: boolean = false;
  newTopics: boolean = false;
  public ShowNote: boolean = false;
  public refrenceValue: any = '';
  public trainingid:any='';
  public contentTypeId: any = '';
  urlStore: any = '';
  boardId: any = '';
  classId: any = '';
  duration: number = 0;
  actualW: number = 0;
  pdfBlobUrl: string | null = null;
  subjName: any = this.$store.state.selectSubjectName;
  private auth = new AuthService();
  private fields = ["index", { key: "fullName", label: "Chapter Name" }];
  private fieldsNew = ["index", { key: "fullName", label: "Topic Name" }, { key: "progress", label: "Watched" }];
  private isVideoTraning: boolean = false;
  private isPdfViewing: boolean = false;
  private currentPdfUrl: string = '';
  private currentPdfTitle: string = '';
  private currentContentFormat: string = '';
  breadcrumbItems: Array<{ text: string; link: any; active?: boolean }> = [];
  // Raw modules from API
  private modules: any[] = [];

  private showModule: boolean = false;
  private selectedModule: any = null;
  private selectedModuleIndex: number = 0;
  private currentModuleId: any = null; // Add this to track current module ID
  private expandedIndex: number | null = null;
  private isVimeoVideo: boolean = false;
  private videoUrl: any = '';
  private IsTraninqQuiz: boolean = false;
  private showQuizInstructionsModal: boolean = false;
  private pendingQuizContent: any = null;
 private  QuizStart: boolean=false;
private previousBreadcrumbItems: Array<{ text: string; link: any; active?: boolean }> = [];
  actionlist: GActivity[];
  trainingmcqlist:  TrainingQuiz | null = null;
  instruction: string | undefined;
 public actionloglist: any[] = [];
 public progressbar:any[]=[];
  public progressPercentage:number=0;
  // Content completion tracking
  private completedContent: Set<string> = new Set();
  private description:string='';
public CertificateResponseList: any = {};
  // Description expansion properties
  private isDescriptionExpanded: boolean = false;
  private showViewMoreButton: boolean = false;
  private studentName:string='';
  private trainingName:string='';
  private IsCertified:boolean=false;
  private certificateUrl:string='';
  private showCertificateModal:boolean=false;
  // Show certificate button when training is completed and certificate exists
  private showViewButton:boolean=false;
  private showSuccesspopUp:boolean=false;
  data() {
    return {
      breadcrumbItems: [

      ],
      // Certificate modal properties
      showCertificateModal: false,
      certificateUrl: '',
      pdfLoadError: false,
      // Success popup properties
      showSuccesspopUp: false
    };
  }
  handleClick(event, type) {

    const itemText = event;
    // if (itemText === "Chapters") {
    this.updateBreadcrumbs(itemText, type);
    // }
  }
  handleClickNew(event, type) {

    this.isVideoTraning = false;
    this.isPdfViewing = false;
    this.IsTraninqQuiz = false;
    this.QuizStart = false; 
    this.breadcrumbItems.pop();
    if (this.breadcrumbItems.length > 0) {
      this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
    }
    //  this.nodataFound = false;
    // }
this.loading = true;
    this.service.getprogressbar(this.selectedModule.trainingId)
      .then((result: any) => {
        this.loading = false;
        
        if (result && typeof result === 'object') {
          this.progressbar = result;
          this.progressPercentage = (result.progressPercentage !== null && result.progressPercentage !== undefined) ? result.progressPercentage : 0;
          this.showSuccesspopUp = false;
          
          if (result.isMandatoryCompleted === true && (!result.isCertificateExist) && this.IsCertified === true) {
            var key = this.selectedModule.trainingId + '?' + this.trainingName + '?' + this.studentName;
            this.loading = true;
            this.service.getcertificate(key).then((result: any) => {
              this.loading = false;
              
              // Add delay to ensure certificate is fully generated
              setTimeout(() => {
                this.showSuccesspopUp = true;
                this.showViewButton = true;
                this.CertificateResponseList = result;
              }, 1500); // Wait 1.5 seconds before showing success popup
            }).catch((err) => {
              this.loading = false;
              console.error('Error fetching certificate:', err);
            });
          }
        } else {
          // Set default values if result is null
          this.progressbar = [];
          this.progressPercentage = 0;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error('Error fetching progress bar:', err);
        // Set default values on error
        this.progressbar = [];
        this.progressPercentage = 0;
      });
      
      this.fetchActionLogs();
  }
  getProgress(value: number | null | undefined): number {
  return typeof value === 'number' && value >= 0 ? value : 0;
}
  updateBreadcrumbs(newTopic, type) {


    this.topicname = newTopic;
    const exists = this.breadcrumbItems.some(
      item => item.text === newTopic
    );
    if (!this.nodataFound) {
      if (!exists) {
        this.breadcrumbItems.forEach(item => {
          item.active = false;
        });
        this.breadcrumbItems.push({
          text: newTopic,
          link: '#',
          active: true,
        });

      }
      else {
        if (this.nodataFound) {
          this.breadcrumbItems.pop();
          if (this.breadcrumbItems.length > 0) {
            this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
          }
        }
        else {

          this.breadcrumbItems.pop();
          if (this.breadcrumbItems.length > 0) {
            this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
          }

        }

      }
    }

  }

  private toggleModule(m: any, idx: number) 
  
  {

    if (this.expandedIndex === idx) {
      this.expandedIndex = null;
      this.selectedModule = null;
      this.selectedModuleIndex = 0;
      this.currentModuleId = null; // Clear module ID when collapsed

    }
    else {
      this.expandedIndex = idx;
      this.selectedModule = m;
      this.selectedModuleIndex = idx;
      // Set the current module ID - adjust the property name based on your API response
      this.currentModuleId = m.id || m.moduleId || m.Id || m.ModuleId || idx;
      
    }
     this.fetchActionLogs();
  }

  private getTopics(m: any): string[] {
    const topics: string[] = [];
    if (!m) return topics;

    // then content items
    if (m.content && Array.isArray(m.content) && m.content.length) {
      m.content.forEach((c: any) => {
        let label = '';
        if (c.contentStatement) {
          try { label = this.stripHtml(c.contentStatement).trim(); } catch (e) { label = String(c.contentStatement || ''); }
        }
        if (!label && c.contentType) label = c.contentType;
        if (!label && c.contentFormat) label = c.contentFormat;
        if (!label && c.referenceType) label = c.referenceType;
        if (!label && c.referenceValue) label = c.referenceValue;
        if (!label) label = 'Untitled Content';
        topics.push(label);
      });
    }
    return topics;
  }

  private getContentLabel(c: any): string {

    let label = '';
    if (!c) return label;
    if (c.contentStatement) {
      try { label = this.stripHtml(c.contentStatement).trim(); } catch (e) { label = String(c.contentStatement || ''); }
    }
    if (!label && c.contentType) label = c.contentType;
    if (!label && c.contentFormat) label = c.contentFormat;
    if (!label && c.referenceType) label = c.referenceType;
    if (!label && c.referenceValue) label = c.referenceValue;
    if (!label) label = 'Untitled Content';
    return label;

  }

 

  private getContentIconClass(c: any): string {
    if (!c) return 'fa fa-file';
    if (c.contentType === 'Supporting Resource') return 'fa fa-file';
    const fmt = (c.contentFormat || '').toString().toLowerCase();
    if (fmt.includes('video')) return 'fa fa-play';
    if (fmt.includes('pdf')) return 'fa fa-file-pdf-o';
    if (fmt.includes('audio')) return 'fa fa-file-audio-o';
    return 'fa fa-file';
  }
  getContentIconHref(c: any): string {
    const spritePath = "../assets/images/file-05.svg"; // your SVG sprite
    let id = 'file'; // default icon


    return `${spritePath}#${id}`;
  }


  private openTopic(topicOrContent: any) {
    if (topicOrContent && typeof topicOrContent === 'object') {
      const c = topicOrContent;
    
      // Mark content as completed when opened
      // this.markContentCompleted(c);
      
      if ((c.contentTypeCode === 'SUPP_RES' || c.contentType === 'Supporting Resource' || c.contentFormat === 'DOCUMENT') && c.contentUrl) {
        if (this.isPdfDocument(c.contentUrl)) {
          this.currentPdfUrl = c.contentUrl;
          this.currentPdfTitle = this.getContentLabel(c);
          this.currentContentFormat = c.contentFormat || '';
          const label = this.getContentLabel(c);
          this.updateBreadcrumbs(label, 'pdf');

          this.isPdfViewing = true;
          
          // Scroll to top when opening PDF viewer
          window.scrollTo(0, 0);

          this.contentType = c.contentTypeCode;
          this.refrenceValue = c.contentId;
          this.trainingid = c.trainingId;
          const key = this.contentType + '?' + this.refrenceValue + '?' + this.selectedModule.trainingId + '?' + this.currentModuleId;
          this.service.getprofileactionlog(key).then((result) => {
            this.actionlist = result;
          });    

          return;
        } else if (c.contentFormat !== 'VIDEO') {
          try {
            window.open(c.contentUrl, '_blank');
          } catch (e) {
            window.location.href = c.contentUrl;
          }
          return;
        }
        else if (c.contentFormat === 'VIDEO') {
          this.contentType = c.contentType;
          this.refrenceValue = this.$store.state.selectSubject;
          this.contentIds = c.contentId;
          this.contentTypeId = c.contentTypeId;
          this.isVimeoVideo = true;
          this.videoUrl = c.contentUrl;
          
          // update breadcrumbs and title
          const label = this.getContentLabel(c);
          this.updateBreadcrumbs(label, 'topic');

          this.topicname = this.stripHtml(topicOrContent.contentStatement);

          this.isVideoTraning = true;
          
          // Scroll to top when opening video viewer
          window.scrollTo(0, 0);
          
           var contentTypeCode = c.contentTypeCode;
          const key = contentTypeCode + '?' + this.contentIds + '?' + this.selectedModule.trainingId + '?' + this.currentModuleId;
          this.service.getprofileactionlog(key).then((result) => {
            this.actionlist = result;
          }); 
          return;
        }

      }
      else if (c.contentFormat === 'TRAINING_QUIZ' || c.contentTypeCode === null || c.referenceType ==='TRAINING_QUIZ') {

        // ✅ Save breadcrumb state BEFORE opening modal
        this.previousBreadcrumbItems = JSON.parse(
          JSON.stringify(this.breadcrumbItems)
        );

        this.pendingQuizContent = c;
        // Add trainingId from the current module
        if (this.selectedModule && this.selectedModule.trainingId) {
          this.pendingQuizContent.trainingId = this.selectedModule.trainingId;
        }
        this.val = this.currentModuleId + '?' + c.referenceValue;
           this.loading = true;
        this.service.getTrainingQuiz(this.val).then((result) => {
          if(result !==null)
        { 
          this.loading = false;
          this.trainingmcqlist = result.data;
          console.log( this.trainingmcqlist,' this.trainingmcqlist');
          this.instruction=this.trainingmcqlist?.instruction;
          this.showQuizInstructionsModal = true;}
          // else{
          //   this.loading = false;
          // }
        });
        document.body.classList.add('modal-open');
        return;
      }
      else if (c.contentTypeCode === 'FULL_LENGTH' || c.contentTypeCode === 'BITE_SIZE' || c.contentTypeCode === 'ANIMATION' || c.parentContentTypeCode==='VIDEO') {
        this.contentType = c.contentType;
        this.refrenceValue = this.$store.state.selectSubject;
        this.contentIds = c.contentId;
        this.contentTypeId = c.contentTypeId;
        this.videoUrl = '';
        // update breadcrumbs and title
        const label = this.getContentLabel(c);
        this.updateBreadcrumbs(label, 'topic');

        this.topicname = this.stripHtml(topicOrContent.contentStatement);

        this.isVideoTraning = true;
        this.isVimeoVideo = false;
        
        // Scroll to top when opening video viewer
        window.scrollTo(0, 0);
        
        var contentTypeCode = c.contentTypeCode;
          const key = contentTypeCode + '?' + this.contentIds + '?' + this.selectedModule.trainingId + '?' + this.currentModuleId;
          this.service.getprofileactionlog(key).then((result) => {
            this.actionlist = result;
          }); 
        return;
      }
        else if (c.contentFormat === 'VIDEO') {
          this.contentType = c.contentType;
          this.refrenceValue = this.$store.state.selectSubject;
          this.contentIds = c.contentId;
          this.contentTypeId = c.contentTypeId;
          this.isVimeoVideo = true;
          this.videoUrl = c.contentUrl;
          
          // update breadcrumbs and title
          const label = this.getContentLabel(c);
          this.updateBreadcrumbs(label, 'topic');

          this.topicname = this.stripHtml(topicOrContent.contentStatement);

          this.isVideoTraning = true;
          
          // Scroll to top when opening video viewer
          window.scrollTo(0, 0);
          
           var contentTypeCode = c.contentTypeCode;
          const key = contentTypeCode + '?' + this.contentIds + '?' + this.selectedModule.trainingId + '?' + this.currentModuleId;
          this.service.getprofileactionlog(key).then((result) => {
            this.actionlist = result;
          }); 
          return;
        }
      return;
    }

    // Fallback: a plain string topic name
    const topicName = String(topicOrContent || '');
    this.updateBreadcrumbs(topicName, 'topic');
    this.isTopic = true;
  }

// private isContentCompleted(c: any): boolean {
//   if (!c || !Array.isArray(this.actionloglist)) {
//     return false;
//   }

//   return this.actionloglist.some(
//     (log: any) => log.entityId === c.contentId
//            && log.parentEntityValue=== this.currentModuleId
//   );
// }
private isContentCompleted(c: any): boolean {
  if (!c || !Array.isArray(this.actionloglist)) {
    return false;
  }

  return this.actionloglist.some((log: any) => {
    // const isSameModule =
    //   log.parentEntityValue === this.currentModuleId;

    // ✅ Case 1: Normal content (contentId exists)
    if (c.contentId) {
      return (
        log.entityId === c.contentId 
        // &&
        // isSameModule
      );
    }

    // ✅ Case 2: Training quiz (contentId is null → use referenceValue)
    if (
      c.contentFormat === 'TRAINING_QUIZ' ||
      c.contentTypeCode === 'TRAINING_QUIZ'
    ) {
      // Check if the log matches this quiz
      const isMatchingQuiz = log.entityId === c.referenceValue;
      
      if (!isMatchingQuiz) {
        return false;
      }
      
   
      if (log.isGraded === false) {
        return true;
      }
      
    
      if (log.isGraded === true) {
        return log.isPassed === true;
      }
      
      
      return true;
    }

    return false;
  });
}

// Check if all content in a module is completed
private isModuleCompleted(module: any): boolean {
  if (!module || !module.content || !Array.isArray(module.content) || module.content.length === 0) {
    return false;
  }

  // Check if all content items in the module are completed
  return module.content.every((content: any) => this.isContentCompleted(content));
}

// Get quiz status for graded quizzes
private getQuizStatus(c: any): { show: boolean; status: 'Passed' | 'Failed' } | null {
  if (!c || !Array.isArray(this.actionloglist)) {
    return null;
  }

  // Only show status for training quizzes
  if (c.contentFormat !== 'TRAINING_QUIZ' && c.contentTypeCode !== 'TRAINING_QUIZ') {
    return null;
  }

  // Find the matching log for this quiz
  const log = this.actionloglist.find((log: any) => log.entityId === c.referenceValue);

  if (!log) {
    return null;
  }

  // Only show status if isGraded is true
  if (log.isGraded === true) {
    return {
      show: true,
      status: log.isPassed === true ? 'Passed' : 'Failed'
    };
  }

  return null;
}


  public checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  private slidePrev(x) {
    (this.$refs[x] as any)[0].swiper.slidePrev();
  }

  private slideNext(x) {
    (this.$refs[x] as any)[0].swiper.slideNext();
  }

  private quizClicked(event, item) {
    event.stopPropagation();
    this.topicid = item.id;

    this.isVideoQuiz = true;
  }

  private swiperOption = {
    slidesPerView: 3,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
      1000: {
        slidesPerView: 2,
      },
    },
  };
  SetTopic() {

  }
  private topicChangeParent(value) {
    this.videoKey++;
  }
  stripHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  private isPdfDocument(url: string): boolean {
    if (!url) return false;

    // Check file extension
    const urlLower = url.toLowerCase();
    if (urlLower.includes('.pdf')) return true;

    // Check for common PDF hosting patterns
    if (urlLower.includes('pdf') || urlLower.includes('document')) return true;

    // Check for file download patterns that might be PDFs
    if (urlLower.includes('download') && urlLower.includes('file')) return true;

    return false;
  }

  private closePdfViewer(): void {
    this.isPdfViewing = false;
    this.currentPdfUrl = '';
    this.currentPdfTitle = '';
    this.currentContentFormat = '';

    // Remove the PDF breadcrumb item
    this.breadcrumbItems.pop();
    if (this.breadcrumbItems.length > 0) {
      this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
    }
    
    // Refresh action logs to update completion status
    this.fetchActionLogs();
    
    // Refresh progress bar
    this.refreshProgressBar();
  }

  private closeVideoViewer(): void {
    this.isVideoTraning = false;
    this.contentIds = '';
    this.contentTypeId = '';
    this.videoUrl = '';
    
    // Remove the video breadcrumb item
    this.breadcrumbItems.pop();
    if (this.breadcrumbItems.length > 0) {
      this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
    }
    
    // Refresh action logs to update completion status
    this.fetchActionLogs();
    
    // Refresh progress bar
    this.refreshProgressBar();
  }

  private closeQuizViewer(): void {
    this.QuizStart = false;
    this.IsTraninqQuiz = false;
    this.refrenceValue = '';
    
    // Remove the quiz breadcrumb item
    this.breadcrumbItems.pop();
    if (this.breadcrumbItems.length > 0) {
      this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
    }
    
    // Refresh action logs to update completion status
    this.fetchActionLogs();
    
    // Refresh progress bar
    this.refreshProgressBar();
  }

 beginQuiz(): void {
  this.showQuizInstructionsModal = false;
  document.body.classList.remove('modal-open');

  this.QuizStart = true;
  this.IsTraninqQuiz = true;
  
  // Scroll to top when quiz starts
  window.scrollTo(0, 0);

  if (this.pendingQuizContent) {
    const label = this.getContentLabel(this.pendingQuizContent);

    // ✅ NOW update breadcrumb
    this.updateBreadcrumbs(label, 'topic');

    this.contentType = this.pendingQuizContent.referenceType;
    this.refrenceValue = this.pendingQuizContent.referenceValue;
    this.trainingid= this.pendingQuizContent.trainingId;
    this.pendingQuizContent = null;
  }
   const key = this.contentType +'?'+this.refrenceValue+'?'+this.trainingid+'?'+this.currentModuleId;
   this.service.trainiguseractionlog(key).then((result) => {
     this.actionlist = result;
  });
}
 closeQuizModal(): void {
  this.showQuizInstructionsModal = false;
  document.body.classList.remove('modal-open');

  // ✅ Restore breadcrumbs
  if (this.previousBreadcrumbItems.length) {
    this.breadcrumbItems = JSON.parse(
      JSON.stringify(this.previousBreadcrumbItems)
    );
  }

  this.pendingQuizContent = null;
}


  mounted() {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    
    // Set flag that we've properly loaded this component
    sessionStorage.setItem('trainingModulesLoaded', 'true');
  }

  beforeDestroy() {
    // Clear the flag when leaving the component
    sessionStorage.removeItem('trainingModulesLoaded');
    sessionStorage.removeItem('navigatedFromCourses');
  }

  beforeRouteLeave(to, from, next) {
    const answer = window.confirm(
      "Do you really want to leave? you have unsaved changes!"
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  }

  created() {

    this.loading = true;
    this.level_id = this.$store.state.selectSubject;
    
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      // router.push("select");
    }


    this.isSmart = false;
    this.contentType = "Training Courses";


    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      if (this.$route.query.type) {
        router.push("trainingcourses");
      }

    }
    if (!this.$store.state.selectSubject || this.$store.state.selectSubject === '' ||
      this.$store.state.selectSubject === 'null' || this.$store.state.selectSubject === null) {
      this.$router.push({ name: 'trainingcourses' });
      return;
    }

    let str = '';
    if (this.auth.session.userName === "facebook@pgc.edu") {
      let fbjson = localStorage[config.fbLogin];
      let userinformation;
      if (fbjson !== undefined && fbjson !== "error") {
        userinformation = JSON.parse(localStorage[config.fbLogin]);

        let temp_str =
          this.auth.session.userId +
          ":" +
          userinformation.id +
          ":" +
          userinformation.name +
          ":" +
          userinformation.email;

        this.service.processFb(temp_str).then((result) => {
          this.loading = false;
          this.mcqlimit = result[0].mcQs;
          this.chapterlimit = result[0].chapters;
          this.topiclimit = result[0].topics;
        });
      } else {
        this.auth.logout();
      }
    }

    this.service.getInfoEMS(localStorage[config.username])
      .then((result) => {
        // this.loading = false;
        if (result && result.data && result.data[0]) {
          try {
            const first = result.data[0];
            this.studentName=first.Name;
            if (typeof first === 'string' && first.length > 0) {
              str = (first as any).toLowerCase();
            } else if (first.Class) {
              str = String(first.Class).toLowerCase();
            }
          } catch (e) {
            // ignore
          }
        }
      })
      .catch((e) => {
        console.warn('getInfoEMS failed', e);
      });


    this.newChapter = true;

    this.breadcrumbItems.push({
      text: this.contentType,
      link: "selectEL",
      active: false
    });

    this.contentType = 'Training Modules';

    // If a course was selected on the previous screen, show it in breadcrumbs (only once)
    const subjName = this.$store.state.selectSubjectName;
    const Id = this.$store.state.selectSubject;

    if (subjName && subjName !== '') {
      const exists = this.breadcrumbItems.some(item => item.text === subjName);
      if (!exists) {
        this.breadcrumbItems.push({
          text: subjName,
          link: "trainingcourses",
          active: true,
        });
      }
    }

    this.service
      .getTrainingModules(Id)
      .then((result: any) => {
        this.loading = false;
        const res: any = result;

        
         this.description=result.description;
         this.trainingName=result.name;
         this.IsCertified=result.isCertified;
        // Extract modules array from possible response shapes
        let modulesArray: any[] = [];
        if (res && Array.isArray(res)) {
          modulesArray = res;
        } else if (res && res.modules && Array.isArray(res.modules)) {
          modulesArray = res.modules;
        } else if (res && res.data && Array.isArray(res.data)) {
          modulesArray = res.data;
        } else if (res && res.data && res.data.modules && Array.isArray(res.data.modules)) {
          modulesArray = res.data.modules;
        } else {
          modulesArray = [];
        }

        this.items = modulesArray as any;
        this.chapters = modulesArray as any;
        this.modules = modulesArray;
         
        if (this.modules && this.modules.length > 0) {
          this.nodataFound = false;

          // ✅ OPEN FIRST MODULE BY DEFAULT
          this.expandedIndex = 0;
          this.selectedModuleIndex = 0;
          this.selectedModule = this.modules[0];
        
          
          
          this.currentModuleId =
            this.modules[0].id ||
            this.modules[0].moduleId ||
            this.modules[0].Id ||
            this.modules[0].ModuleId ||
            0;
             this.fetchActionLogs();
          
            this.service.getprogressbar(this.selectedModule.trainingId)
      .then((result: any) => {
        this.loading = false;
        
        if (result && typeof result === 'object') {
          this.progressbar = result;
          this.showViewButton = (result.isCertificateExist !== null && result.isCertificateExist !== undefined) ? result.isCertificateExist : false;
          this.progressPercentage = (result.progressPercentage !== null && result.progressPercentage !== undefined) ? result.progressPercentage : 0;
          this.showSuccesspopUp = false;

          if (result.isMandatoryCompleted === true && (!result.isCertificateExist) && this.IsCertified === true) {
            var key = this.selectedModule.trainingId + '?' + this.trainingName + '?' + this.studentName;
            this.service.getcertificate(key).then((certResult: any) => {
              // Add delay to ensure certificate is fully generated
              setTimeout(() => {
                this.CertificateResponseList = certResult;
                this.showViewButton = true;
                this.showSuccesspopUp = true;
              }, 1500); // Wait 1.5 seconds before showing success popup
            }).catch((err) => {
              console.error('Error fetching certificate:', err);
            });
          }
        } else {
          // Set default values if result is null
          this.progressbar = [];
          this.showViewButton = false;
          this.progressPercentage = 0;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error('Error fetching progress bar:', err);
        // Set default values on error
        this.progressbar = [];
        this.showViewButton = false;
        this.progressPercentage = 0;
      })

         
        } else {
          this.nodataFound = true;
        }
        
        // Check description height after data is loaded
        setTimeout(() => {
          this.checkDescriptionHeight();
        }, 100);
        
        
      })

      .catch((err) => {
        this.loading = false;
        console.error(`Error: ${err.message}`);
      });


  }
  
private fetchActionLogs(): void {
  
  if (!this.selectedModule?.trainingId) {
    console.warn('trainingId missing for module', this.selectedModule);
    return;
  }

  this.service
    .getGetActionLogs(this.selectedModule.trainingId)
    .then((result: any) => {
      
      this.actionloglist = Array.isArray(result) ? result : [];
      console.log('Fetched action logs', this.actionloglist);
    });
}

// Refresh progress bar
private refreshProgressBar(): void {
  if (!this.selectedModule?.trainingId) {
    console.warn('trainingId missing for module', this.selectedModule);
    return;
  }

  this.service
    .getprogressbar(this.selectedModule.trainingId)
    .then((result: any) => {
      if (result && typeof result === 'object') {
        this.progressbar = result;
        this.progressPercentage = (result.progressPercentage !== null && result.progressPercentage !== undefined) ? result.progressPercentage : 0;
        this.showSuccesspopUp = false;

        // Check if training is completed and certificate should be shown
        if (result.isMandatoryCompleted === true && (!result.isCertificateExist) && this.IsCertified === true) {
          const key = this.selectedModule.trainingId + '?' + this.trainingName + '?' + this.studentName;
          this.service.getcertificate(key).then((certResult: any) => {
            // Add delay to ensure certificate is fully generated
            setTimeout(() => {
              this.CertificateResponseList = certResult;
              this.showViewButton = true;
              this.showSuccesspopUp = true;
            }, 1500); // Wait 1.5 seconds before showing success popup
          }).catch((err) => {
            console.error('Error fetching certificate:', err);
          });
        }
      } else {
        // Set default values if result is null
        this.progressbar = [];
        this.progressPercentage = 0;
      }
    })
    .catch((err) => {
      console.error('Error refreshing progress bar:', err);
      // Set default values on error
      this.progressbar = [];
      this.progressPercentage = 0;
    });
}

// Description expansion methods
private toggleDescription(): void {
  this.isDescriptionExpanded = !this.isDescriptionExpanded;
}

private checkDescriptionHeight(): void {
  this.$nextTick(() => {
    const descriptionElement = this.$refs.descriptionText as HTMLElement;
    if (descriptionElement && this.description && this.description.trim()) {
      // Create a temporary element to measure the full height
      const tempElement = descriptionElement.cloneNode(true) as HTMLElement;
      tempElement.style.maxHeight = 'none';
      tempElement.style.position = 'absolute';
      tempElement.style.visibility = 'hidden';
      tempElement.style.height = 'auto';
      tempElement.style.top = '-9999px';
      tempElement.style.left = '-9999px';
      
      document.body.appendChild(tempElement);
      const fullHeight = tempElement.scrollHeight;
      document.body.removeChild(tempElement);
      
      this.showViewMoreButton = fullHeight > 80; // Show button if content exceeds 80px
    } else {
      this.showViewMoreButton = false;
    }
  });
}

// View certificate method
  viewCertificate(): void {
    if (this.CertificateResponseList.filePath != null && this.CertificateResponseList.filePath != undefined) {
      this.certificateUrl = this.CertificateResponseList.filePath;
    }
    else {
      this.certificateUrl = this.$store.state.certficateurl;
    }
    console.log("certificateUrl", this.certificateUrl);
    
    // Add a small delay to ensure certificate is ready
    setTimeout(() => {
      this.showCertificateModal = true;
      document.body.classList.add('modal-open');
    }, 500);
  }

async loadPdf() {
    try {
      const response = await fetch(this.certificateUrl);
      if (!response.ok) throw new Error("PDF fetch failed");

      const blob = await response.blob();
      this.pdfBlobUrl = URL.createObjectURL(blob);
    } catch (e) {
      console.error(e);
      alert("Failed to load PDF");
    }
  }
// Close certificate modal
private closeCertificateModal(): void {
  this.showCertificateModal = false;
  document.body.classList.remove('modal-open');
  // Clear certificate URL after a short delay to prevent rendering cancellation
  setTimeout(() => {
    this.certificateUrl = '';
  }, 300);
}

// Download certificate with retry logic
private async downloadCertificate(): Promise<void> {
  try {
    const url =
      this.CertificateResponseList?.filePath ||
      this.CertificateResponseList?.certificateUrl ||
      this.$store.state.certficateurl;

    if (!url) {
      alert('Certificate URL not available. Please try again.');
      return;
    }

    // Retry logic for certificate download
    let retries = 3;
    let response;
    
    while (retries > 0) {
      try {
        response = await fetch(url);
        
        if (response.ok) {
          break; // Success, exit retry loop
        }
        
        // If not ok and retries left, wait and retry
        if (retries > 1) {
          await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
          retries--;
        } else {
          throw new Error('Failed to fetch certificate after retries');
        }
      } catch (error) {
        if (retries > 1) {
          await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
          retries--;
        } else {
          throw error;
        }
      }
    }

    if (!response || !response.ok) {
      throw new Error('Failed to download certificate');
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${this.trainingName}_certificate.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading certificate:', error);
    alert('Failed to download certificate. Please try again in a moment.');
  }
}

// Success modal methodsget
private closeSuccessModal(): void {
  this.showSuccesspopUp = false;
  document.body.classList.remove('modal-open');
}

private viewCertificateFromSuccess(): void {
  this.viewCertificate();
  // this.closeSuccessModal();
  this.showSuccesspopUp = false;
}
}
